
export default function AboutPreview() {
  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-3">About Us</p>
            <h2 className="text-4xl md:text-5xl font-bold text-neutral-700 mb-6">
              Why Choose Brushour for Your Watford Painting Project?
            </h2>
            <div className="space-y-4 text-base text-neutral-600 leading-relaxed">
              <p>
                As <strong>professional painters and decorators in Watford</strong>, we've been transforming homes and businesses across <strong>Hertfordshire</strong> for over 18 years. Our commitment to excellence and customer satisfaction has made us the trusted choice for <strong>painting services in Rickmansworth</strong>, <strong>Chorleywood</strong>, and surrounding areas.
              </p>
              <p>
                Whether you need <strong>interior painting in Watford</strong>, <strong>exterior painting</strong>, or specialist services like <strong>limewash painting</strong> and <strong>spray painting</strong>, our experienced team delivers outstanding results every time. We understand that your property is your most valuable asset, which is why we treat every <strong>painting project in Hertfordshire</strong> with the care and attention it deserves.
              </p>
              <p>
                Our <strong>local painters and decorators</strong> are fully insured with £1 million public liability coverage, giving you complete peace of mind. We use only premium materials and proven techniques to ensure your <strong>Watford painting project</strong> stands the test of time.
              </p>
            </div>
            
            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-700 mb-1">Free Quotes</h3>
                  <p className="text-sm text-neutral-600">No-obligation estimates across <strong>Watford</strong></p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-2xl text-sky-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-700 mb-1">Fully Insured</h3>
                  <p className="text-sm text-neutral-600">£1M public liability coverage</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-fill text-2xl text-amber-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-700 mb-1">18+ Years</h3>
                  <p className="text-sm text-neutral-600">Experience in <strong>Hertfordshire</strong></p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-2xl text-sky-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-700 mb-1">500+ Customers</h3>
                  <p className="text-sm text-neutral-600">Satisfied clients locally</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <a
                href="/about"
                className="inline-flex items-center gap-2 px-8 py-3 bg-neutral-700 text-white text-base font-semibold rounded-lg hover:bg-neutral-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More About Us
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full bg-amber-200/40 rounded-lg"></div>
            <div className="relative aspect-square w-full rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/a9c06fb4f357ef7b4923d54a3bf458ff.jpg"
                alt="Professional painters and decorators working in Watford - Brushour painting services"
                title="Expert painting and decorating services in Watford and Hertfordshire"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-sky-600 text-white p-6 rounded-lg shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-1">4.9/5</div>
              <div className="text-sm">Average rating from 127 verified reviews across <strong>Watford</strong> and <strong>Hertfordshire</strong></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
